// container.js
import React from 'react';
import { JoinCommunityFabView, ShareCommunityButtonView } from './view';
import { joinCommunity, postCommunityAnswers } from 'api';

export const JoinCommunityFab = ({ 
  community, 
  my_membership, 
  onJoinSuccess 
}) => {
  
  const handleJoinRequest = async () => {
    try {
      const response = await joinCommunity({
        community: community.slug
      });
      // Check if response has data property or if response IS the data
      const responseData = response.data || response;
      
      if (responseData) {
        // Notify parent component of successful join
        if (onJoinSuccess) {
          onJoinSuccess(responseData);
        }
        return { success: true, data: responseData };
      } else {
        return { success: false, error: 'No response data' };
      }
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data || error.message || 'Network error' 
      };
    }
  };

  const handleSubmitAdmissionAnswers = async (communitySlug, answers) => {
    try {
      const response = await postCommunityAnswers(communitySlug, {
        answers: answers
      });
      
      // Check if response has data property or if response IS the data
      const responseData = response.data || response;
      
      if (responseData) {
        // Notify parent component of successful answer submission
        if (onJoinSuccess) {
          onJoinSuccess(responseData);
        }
        return { success: true, ...responseData };
      } else {
        console.error('Failed to submit answers: No response data');
        return { success: false, error: 'No response data' };
      }
    } catch (error) {
      console.error('Network error submitting answers:', error);
      return { 
        success: false, 
        error: error.response || error.message || 'Network error' 
      };
    }
  };

  return (
    <JoinCommunityFabView
      community={community}
      my_membership={my_membership}
      onJoinRequest={handleJoinRequest}
      onSubmitAdmissionAnswers={handleSubmitAdmissionAnswers}
    />
  );
};

export const ShareCommunityButton = ({ community }) => {
  return (
    <ShareCommunityButtonView community={community} />
  );
};